import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MonitorService } from './services/monitor/monitor.service';
import { MonitorModuleConfig } from './models/monitor-module-config.model';

@NgModule({
  declarations: [],
  providers: [MonitorService],
  imports: [CommonModule, RouterModule],
})
export class IdeomMonitorModule {
  static forRoot(config: MonitorModuleConfig): ModuleWithProviders<IdeomMonitorModule> {
    return {
      ngModule: IdeomMonitorModule,
      providers: [
        {
          provide: MonitorModuleConfig,
          useValue: config,
        },
      ],
    };
  }
}
